import { createAction } from "@reduxjs/toolkit";
import { FetchableError, FetchableSuccess } from "../common/fetchable/helpers";
import { AuthDTO } from "./models/dto";

export namespace AuthActions {
  export enum ActionTypes {
    authRequest = "Auth: Auth Request",
    authDone = "Auth: Auth Done",
    clearAuthState = "Auth: Clear Auth State",
    clearAuthStateSuccess = "Auth: Clear Auth State Success",
    clearAuthStateFailure = "Auth: Clear Auth State Failure",
    logout = "Auth: Logout",

    impersonateRequest = "Auth: Impersonate Request",
    impersonateDone = "Auth: Impersonate Done",
    stopImpersonationRequest = "Auth: Stop Impersonation Request",
    stopImpersonationDone = "Auth: Stop Impersonation Done",

    setRedirectUrl = "Auth: Set Redirect Url",
  }

  // Actions Types

  export const authRequest = createAction<
    AuthDTO.Requests.AuthRequest.T,
    ActionTypes.authRequest
  >(ActionTypes.authRequest);

  export const authDone = createAction<
    FetchableSuccess<AuthDTO.Responses.Login.T> | FetchableError,
    ActionTypes.authDone
  >(ActionTypes.authDone);

  export const clearAuthState = createAction(ActionTypes.clearAuthState);

  export const logout = createAction(ActionTypes.logout);

  export const clearAuthStateSuccess = createAction(
    ActionTypes.clearAuthStateSuccess
  );

  export const clearAuthStateFailure = createAction<Error>(
    ActionTypes.clearAuthStateFailure
  );

  export const impersonateRequest = createAction<
    AuthDTO.Requests.Impersonate.T,
    ActionTypes.impersonateRequest
  >(ActionTypes.impersonateRequest);

  export const stopImpersonationRequest = createAction(
    ActionTypes.stopImpersonationRequest
  );

  export const setRedirectUrl = createAction<
    string,
    ActionTypes.setRedirectUrl
  >(ActionTypes.setRedirectUrl);

  export type AuthRequest = ReturnType<typeof authRequest>;
  export type AuthSuccess = ReturnType<typeof authDone>;
  export type ClearAuthState = ReturnType<typeof clearAuthState>;
  export type ClearAuthStateSuccess = ReturnType<typeof clearAuthStateSuccess>;
  export type ClearAuthStateFailure = ReturnType<typeof clearAuthStateFailure>;
  export type Logout = ReturnType<typeof logout>;
  export type ImpersonateRequest = ReturnType<typeof impersonateRequest>;
  export type StopImpersonationRequest = ReturnType<
    typeof stopImpersonationRequest
  >;
  export type SetRedirectUrl = ReturnType<typeof setRedirectUrl>;

  // Action Implementations

  export type Actions =
    | AuthRequest
    | AuthSuccess
    | ClearAuthState
    | ClearAuthStateSuccess
    | ClearAuthStateFailure
    | Logout
    | ImpersonateRequest
    | StopImpersonationRequest
    | SetRedirectUrl;
}
